import type { FC } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { AssetsService } from "app/services/AssetsService";

interface ITopicsLoadingSpinnerProps {
    size?: number;
}

export const TopicsLoadingSpinner: FC<ITopicsLoadingSpinnerProps> = ({ size = 170 }) => {
    return (
        <Flex
            data-automation="llm-setup-loading-spinner"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="8px"
        >
            <img
                height={size}
                width={size}
                src={AssetsService.assetUrl("/images/ai-tagging/copilotloader.webp")}
                alt="Analyzing your keywords for topics"
                data-automation="llm-setup-loading-image"
            />
        </Flex>
    );
};
